export const SITE_URL = "https://bullio.org";
export const SITE_NAME = "Bullio Academy";
export const SITE_LOCALE = "en_US";
export const DEFAULT_TITLE = "Bullio Academy | Professional Trading Education";
export const DEFAULT_DESCRIPTION =
  "Learn to trade like a professional with Bullio Academy. Structured courses, live analysis, and a community of 2,400+ traders.";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.webp`;
export const TWITTER_HANDLE = "@BullioAcademy";

export const buildCanonical = (path: string) => {
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${cleanPath === "/" ? "" : cleanPath}`;
};
